import { CoApplicantPipe } from '@hb/modules/global';
import { OwnPropertyPartStoreService } from '@hb/modules/extra-asset/own-property-part/own-property-part-store.service';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { GlobalControl } from '@hb/domain';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { AdditionalInfoComponent } from '@hb/modules';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApContentModule } from '@ap/content';
import { ApButtonGroupComponent, ApButtonGroupItemComponent } from '@ap/button';

@Component({
    selector: 'own-property',
    templateUrl: './own-property.component.html',
    standalone: true,
    imports: [
        ApContentModule,
        ReactiveFormsModule,
        ApButtonGroupComponent,
        ApButtonGroupItemComponent,
        AdditionalInfoComponent,
        CoApplicantPipe
    ],
    providers: [
        { provide: GLOBAL_STORE, useExisting: OwnPropertyPartStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.OWN_PROPERTY }
    ]
})
export class OwnPropertyComponent extends GlobalInjectComponent<OwnPropertyPartStoreService> implements OnInit {
    private readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(OwnPropertyPartStoreService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new GlobalControl<string>(
            this.analyticsService,
            this.questionKey,
            this.store.getOwnProperty()?.toString()
        );
        this.mainApplicantControl.onUpdate().subscribe((value) => this.store.setOwnProperty(Boolean(JSON.parse(value))));
    }

    onButtonGroupClicked($event: string): void {
        this.mainApplicantControl.setValue($event);
    }
}
